export default {
  body: `
    ¿Qué pasaría si se contagiara con el coronavirus?
  `,
  topic: `
    Lo que pasaría si me contagiara con el coronavirus.
  `,
};
